/* eslint-disable no-shadow */

import * as types from '../mutation-types';
import helpers from '../helpers';
import { getStockSplits } from '../../lib/api';
import { transform } from '../helpers/stockSplit';

const state = {
  items: {},
};

const mutations = {
  [types.ADD_STOCK_SPLITS](state, presets) {
    helpers.mutations.createItems(state, presets, transform);
  },
};

const actions = {
  add({ commit }, presets) {
    commit(types.ADD_STOCK_SPLITS, presets);
  },

  async load({ commit }) {
    const presets = await getStockSplits();

    commit(types.ADD_STOCK_SPLITS, presets);
  },
};

const getters = {
  get(state) {
    return (id) => state.items[id];
  },

  getAll(state) {
    return Object.keys(state.items).map((id) => state.items[id]);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
